export default "__VITE_ASSET__f6ac8857__"